import LANG from './en'

/**
 * Data metrics in the SEDA data set
 */
export const METRICS = [
	{
		id: 'mth1922',
		label: LANG['LABEL_MTH1922'],
		range: {
			// 'map_*_gap': [-4, 3.25],
			map_states: [-1, 1],
			map_districts: [-1.75, 1.75],
		},
		regions: ['states','districts'],
	},
	{
		id: 'mth2224',
		label: LANG['LABEL_MTH2224'],
		range: {
			// 'map_*_gap': [-4, 3.25],
			map_states: [-0.6, 0.6],
			map_districts: [-1, 1],
		},
		regions: ['states','districts'],
	},
	{
		id: 'mth1924',
		label: LANG['LABEL_MTH1924'],
		range: {
			// 'map_*_gap': [-4, 3.25],
			map_states: [-0.75, 0.75],
			map_districts: [-1.8, 1.8],
		},
		regions: ['states','districts'],
	},
	{
		id: 'ela1922',
		label: LANG['LABEL_ELA1922'],
		range: {
			// 'map_*_gap': [-4, 4],
			map_states: [-0.6, 0.6],
			map_districts: [-1.5, 1.5],
		},
		regions: ['states','districts'],
	},
	{
		id: 'ela2224',
		label: LANG['LABEL_ELA2224'],
		range: {
			// 'map_*_gap': [-4, 4],
			map_states: [-0.5, 0.5],
			map_districts: [-1, 1],
		},
		regions: ['states','districts'],
	},
	{
		id: 'ela1924',
		label: LANG['LABEL_ELA1924'],
		range: {
			// 'map_*_gap': [-4, 4],
			map_states: [-0.6, 0.6],
			map_districts: [-1.8, 1.8],
		},
		regions: ['states','districts'],
	},
	{
		id: 'abs1923',
		label: LANG['LABEL_ABS1923'],
		range: {
			// 'map_*_gap': [-4, 4],
			map_states: [-0.3, 0.3],
			map_districts: [-0.3, 0.3],
		},
		regions: ['states','districts'],
	},
	{
		id: 'frl',
		label: LANG['LABEL_FRL'],
		map: false,
		scatterplot: true,
		range: {
			// 'map_*_*': [-3, 3]
			map_states: [0, 1],
			map_districts: [0, 1],
		},
		regions: ['states', 'districts']
	},
	// {
	// 	id: 'pef',
	// 	label: LANG['LABEL_PEF'],
	// 	range: {
	// 		// 'map_*_*': [-3, 3],
	// 		map_states: [0, 50],
	// 		map_districts: [0, 110],
	// 	},
	// 	regions: ['states', 'districts']
	// },
	{
		id: 'prm',
		label: LANG['LABEL_PRM'],
		range: {
			// 'map_*_*': [-3, 3],
			map_states: [0, 1],
			map_districts: [0, 1],
		},
		regions: ['states', 'districts']
	}
]

export const KEY_METRIC_IDS = [
	'mth1922',
	'mth2224',
	'mth1924',
	'ela1922',
	'ela2224',
	'ela1924',
	'abs1923',
]

export const DEFAULT_RANGES = {
	states: {
		mth1922: [-10,10],
		mth1924: [-10,10],
		mth2224: [-10,10],
		ela1922: [-10,10],
		ela1924: [-10,10],
		ela2224: [-10,10],
		abs1923: [-10,10],
		frl: [0, 1],
		// pef: [0, 1],
		prm: [0, 1],
		limit: 52
	},
	districts: {
		mth1922: [-10,10],
		mth1924: [-10,10],
		mth2224: [-10,10],
		ela1922: [-10,10],
		ela1924: [-10,10],
		ela2224: [-10,10],
		abs1923: [-10,10],
		frl: [0, 1],
		// pef: [0, 1],
		prm: [0, 1],
		limit: 15000
	},
	// schools: {
	// 	avg: [-5, 5],
	// 	grd: [0, 2],
	// 	coh: [-0.5, 0.5],
	// 	frl: [0, 1],
	// 	limit: 80000
	// }
}

export const UNITS = [
	'gs',
	// 'ns'
]

export const METRICS_FROM_ZERO = [
	'mth1924',
	'mth2224',
	'mth1922',
	'ela1924',
	'ela2224',
	'ela1922',
	'abs1923',
	'ses'
]